import { Skeleton } from "@/shared/components/ui/skeleton"

interface WorkOrdersResultsCountProps {
    total: number
    isLoading: boolean
}

function WorkOrdersResultsCount({
    total,
    isLoading,
}: WorkOrdersResultsCountProps) {
    if (isLoading) {
        return <Skeleton className="h-6 w-32" />
    }

    return (
        <div className="text-sm text-muted-foreground">
            Showing {total.toLocaleString()} work order{total === 1 ? "" : "s"}
        </div>
    )
}

export default WorkOrdersResultsCount
